export default __webpack_public_path__ + "static/media/pokemon-.92ca9b07.jpg";